/* Inspire My Home — Theme JS */

// ——— Helpers ———
function fmtMoney(cents) {
  return '€ ' + (cents / 100).toFixed(2);
}
function escHtml(s) {
  return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

// ——— Search ———
function toggleSearch() {
  var el = document.getElementById('search-bar');
  if (!el) return;
  var isOpen = el.classList.toggle('is-open');
  el.setAttribute('aria-hidden', !isOpen);
  if (isOpen) setTimeout(function() { el.querySelector('.imh-header__search-input').focus(); }, 50);
}

// ——— Mobile Nav ———
function openMobileNav() {
  var el = document.getElementById('mobile-nav');
  if (!el) return;
  el.classList.add('is-open');
  el.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeMobileNav() {
  var el = document.getElementById('mobile-nav');
  if (!el) return;
  el.classList.remove('is-open');
  el.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
// Aliases for legacy calls
var openMobileMenu = openMobileNav;
var closeMobileMenu = closeMobileNav;

// ——— Cart Drawer ———
function openCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function updateCartCount() {
  refreshCartDrawer();
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCountBadge(cart.item_count);
      buildCartDrawer(cart);
    })
    .catch(function() {});
}

function updateCartCountBadge(count) {
  var badge = document.querySelector('.cart-count');
  var btn   = document.querySelector('.imh-header__cart-btn');
  if (!btn) return;
  if (count > 0) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart-count';
      btn.appendChild(badge);
    }
    badge.textContent = count;
  } else if (badge) {
    badge.remove();
  }
}

function buildCartDrawer(cart) {
  var body = document.getElementById('cart-drawer-items');
  if (!body) return;

  var countEl = document.getElementById('cart-drawer-count');
  if (countEl) {
    countEl.textContent = cart.item_count > 0
      ? cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items')
      : '';
  }

  if (!cart.items || !cart.items.length) {
    body.innerHTML =
      '<div class="cart-drawer__empty">' +
        '<div class="cart-drawer__empty-icon">&#x1F6D2;</div>' +
        '<p class="cart-drawer__empty-title">Your cart is empty</p>' +
        '<p class="cart-drawer__empty-sub">Discover our collection and find something beautiful for your home.</p>' +
        '<a href="/collections/all" onclick="closeCartDrawer()" class="cart-drawer__empty-btn">Discover the collection &rarr;</a>' +
      '</div>';
    return;
  }

  var itemsHtml = '';
  cart.items.forEach(function(item) {
    var imgSrc  = item.image ? item.image.split('?')[0] + '?width=140&height=140&crop=center' : '';
    var imgHtml = imgSrc
      ? '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(item.title) + '" width="80" height="80" loading="lazy">'
      : '<div class="cart-drawer__img-empty"></div>';
    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cart-drawer__item-variant">' + escHtml(item.variant_title) + '</p>' : '';
    var key = escHtml(item.key);

    itemsHtml +=
      '<div class="cart-drawer__item">' +
        '<a href="' + escHtml(item.url) + '" class="cart-drawer__item-img">' + imgHtml + '</a>' +
        '<div class="cart-drawer__item-details">' +
          '<a href="' + escHtml(item.url) + '" class="cart-drawer__item-name">' + escHtml(item.product_title) + '</a>' +
          variantHtml +
          '<div class="cart-drawer__item-row">' +
            '<div class="cart-drawer__qty">' +
              '<button onclick="cartChange(\'' + key + '\',' + (item.quantity - 1) + ')" class="cart-drawer__qty-btn" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="cart-drawer__qty-num">' + item.quantity + '</span>' +
              '<button onclick="cartChange(\'' + key + '\',' + (item.quantity + 1) + ')" class="cart-drawer__qty-btn" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<p class="cart-drawer__item-price">' + fmtMoney(item.final_line_price) + '</p>' +
          '</div>' +
          '<button onclick="cartChange(\'' + key + '\',0)" class="cart-drawer__remove">Remove</button>' +
        '</div>' +
      '</div>';
  });

  var footerHtml =
    '<div class="cart-drawer__footer">' +
      '<div class="cart-drawer__subtotal">' +
        '<span>Subtotal</span>' +
        '<strong>' + fmtMoney(cart.total_price) + '</strong>' +
      '</div>' +
      '<p class="cart-drawer__ship-note">🚚&nbsp; Free shipping on all orders &mdash; always.</p>' +
      '<a href="/checkout" class="cart-drawer__checkout-btn">' +
        '🔒&nbsp; Secure Checkout &rarr;' +
      '</a>' +
      '<a href="/cart" onclick="closeCartDrawer()" class="cart-drawer__view-cart">View full cart</a>' +
      '<div class="cart-drawer__trust">' +
        '<span>✅ 30-day returns</span>' +
        '<span class="cart-drawer__trust-sep">&middot;</span>' +
        '<span>🔒 Encrypted & safe</span>' +
      '</div>' +
    '</div>';

  body.innerHTML = itemsHtml + footerHtml;
}

function cartChange(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function() { refreshCartDrawer(); })
  .catch(function() {});
}

// ——— Product Carousel ———
function carouselNext(sectionId) {
  var track = document.getElementById('track-' + sectionId);
  if (!track) return;
  var card = track.querySelector('.product-card, .product-card--placeholder');
  var cardWidth = card ? (card.offsetWidth + 16) : 300;
  track.scrollBy({ left: cardWidth * 2, behavior: 'smooth' });
}
function carouselPrev(sectionId) {
  var track = document.getElementById('track-' + sectionId);
  if (!track) return;
  var card = track.querySelector('.product-card, .product-card--placeholder');
  var cardWidth = card ? (card.offsetWidth + 16) : 300;
  track.scrollBy({ left: -cardWidth * 2, behavior: 'smooth' });
}

// ——— Quick Add To Cart ———
function quickAddToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    openCartDrawer();
  })
  .catch(function(err) { console.error('Quick add failed:', err); });
}

// ——— Keyboard ———
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeCartDrawer();
    closeMobileNav();
    var search = document.getElementById('header-search');
    if (search && search.classList.contains('is-open')) toggleSearch();
  }
});

// ——— Sticky header shadow ———
(function() {
  var header = document.getElementById('site-header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.08)' : '';
  }, { passive: true });
})();

// ——— Newsletter anchor scroll ———
document.querySelectorAll('a[href="#newsletter"]').forEach(function(el) {
  el.addEventListener('click', function(e) {
    var target = document.getElementById('newsletter');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
  });
});
